/** Check if the value is a number */
export function isNumber(value: unknown) {
  return typeof value === 'number' && Number.isFinite(value);
}

/**
 * A wrapper for fetch that adds an Authorization header if an authToken is present in localStorage.
 * @param url - The URL to fetch.
 * @param options - The options for the fetch request.
 * @returns A promise that resolves with the Response.
 */
export function fetchWithAuth(url: string, options: RequestInit): Promise<Response> {
  const authToken = localStorage.getItem('authToken');
  const headers = new Headers(options.headers);

  if (authToken) {
    headers.set('Authorization', 'Bearer-Embed ' + authToken);
  }

  return fetch(url, {
    ...options,
    headers,
  });
}
